import { render, staticRenderFns } from "./ShareBox.vue?vue&type=template&id=25f62fa4"
import script from "./ShareBox.js?vue&type=script&lang=js&external"
export * from "./ShareBox.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports